"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarAnswerWithArrayWidget = void 0;
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var InfoRadioQuestionWidget_1 = require("./InfoRadioQuestionWidget");
var PolarAnswerWithArrayWidget = /** @class */ (function (_super) {
    __extends(PolarAnswerWithArrayWidget, _super);
    function PolarAnswerWithArrayWidget(props) {
        var _this = this;
        props.question.settings.classifier = "polarAnswer";
        _this = _super.call(this, props) || this;
        var originalHandleOnChange = _this.handleOnChangeEvent;
        _this.handleOnChangeEvent = function (event) {
            originalHandleOnChange.call(_this, event);
            _this.postHandleChange();
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    PolarAnswerWithArrayWidget.prototype.getValue = function () {
        return this.bindFromField(this.props.question.interactionField);
    };
    PolarAnswerWithArrayWidget.prototype.postHandleChange = function () {
        if (this.getValue() === "false") {
            journey_services_1.ObjectManipulator.setField(this.props.question.settings.arrayField, this.props.interaction, []);
        }
    };
    PolarAnswerWithArrayWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "arrayField", type: journey_model_1.TypeDescriptions.String }
        ])
        /*
         * A yes/no answer widget that has an array associated with it, which has to be cleared on a "No" answer.
         * (The array is usually related to a panel which opens underneath on "Yes" answer.)
         */
        ,
        __metadata("design:paramtypes", [Object])
    ], PolarAnswerWithArrayWidget);
    return PolarAnswerWithArrayWidget;
}(InfoRadioQuestionWidget_1.InfoRadioQuestionWidget));
exports.PolarAnswerWithArrayWidget = PolarAnswerWithArrayWidget;
//# sourceMappingURL=PolarAnswerWithArrayWidget.js.map